module.exports = __webpack_public_path__ + "static/007479-35a0f55eb604568b697d1ed7320db76e.jpg";